<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="客户" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="订单号" min-width="100" prop="dingdanhao"></el-table-column>
          <el-table-column align="center" label="货号" min-width="100" prop="huohao"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="chanpinguige"></el-table-column>
          <el-table-column align="center" label="订单数量" min-width="100" prop="dingdanshuliang"></el-table-column>
          <el-table-column align="center" label="颜色" min-width="100" prop="yanse"></el-table-column>
          <el-table-column align="center" label="物料名称" min-width="100" prop="wuliaomingcheng"></el-table-column>
          <el-table-column align="center" label="物料规格" min-width="100" prop="wuliaoguige"></el-table-column>
          <el-table-column align="center" label="材质" min-width="100" prop="caizhi"></el-table-column>
          <el-table-column align="center" label="单伞用量" min-width="100" prop="dansanyongliang"></el-table-column>
          <el-table-column align="center" label="物料标准量" min-width="100" prop="biaozhunliang"></el-table-column>
          <el-table-column align="center" label="单根工价普工" min-width="100" prop="danjiapugong"></el-table-column>
          <el-table-column align="center" label="单根工价枪手" min-width="100" prop="danjiaqiangshou"></el-table-column>
          <el-table-column align="center" label="期初外协/库存数量" min-width="100" prop="qichukucun"></el-table-column>
          <el-table-column align="center" label="期初喷塑产量" min-width="100" prop="qichuchanliang"></el-table-column>
          <el-table-column align="center" label="外协/库存数量" min-width="150" prop="kucun"></el-table-column>
          
          <el-table-column align="center" label="当日产量普工一线白班" min-width="120" prop="chanliang1"></el-table-column>
          <el-table-column align="center" label="当日产量普工一线白班1" min-width="120" prop="chanliang11"></el-table-column>
          <el-table-column align="center" label="当日产量普工二线白班" min-width="120" prop="chanliang2"></el-table-column>
          <el-table-column align="center" label="当日产量普工二线白班1" min-width="120" prop="chanliang21"></el-table-column>
          <el-table-column align="center" label="当日产量普工三线白班" min-width="120" prop="chanliang3"></el-table-column>
          <el-table-column align="center" label="当日产量普工四线白班" min-width="120" prop="chanliang4"></el-table-column>
          <el-table-column align="center" label="当日产量普工四线白班1" min-width="120" prop="chanliang41"></el-table-column>
          <el-table-column align="center" label="当日产量普工三线白班" min-width="120" prop="chanliang5"></el-table-column>
          <el-table-column align="center" label="当日产量普工三线白班1" min-width="120" prop="chanliang6"></el-table-column>
          <el-table-column align="center" label="当日产量普工一线夜班" min-width="120" prop="chanliang7"></el-table-column>
          <el-table-column align="center" label="当日产量普工一线夜班" min-width="120" prop="chanliang8"></el-table-column>
          <el-table-column align="center" label="当日产量其他" min-width="120" prop="chanliang9"></el-table-column>
          
          <el-table-column align="center" label="订单欠量" min-width="100" prop="dingdanqianliang"></el-table-column>
          <el-table-column align="center" label="本月外协/库存数量" min-width="100" prop="benyuekucun"></el-table-column>
          <el-table-column align="center" label="当日产量" min-width="120" prop="chanliangheji"></el-table-column>
          <el-table-column align="center" label="本月累计产量" min-width="100" prop="benyuechanliang"></el-table-column>
          <el-table-column align="center" label="累计外协/库存数量" min-width="100" prop="leijikucun"></el-table-column>
          <el-table-column align="center" label="累计产量" min-width="100" prop="leijichanliang"></el-table-column>
          
          <el-table-column align="center" label="普工一线白班" min-width="120" prop="jinepugong1"></el-table-column>
          <el-table-column align="center" label="普工一线白班1" min-width="120" prop="jinepugong11"></el-table-column>
          <el-table-column align="center" label="普工二线白班" min-width="120" prop="jinepugong2"></el-table-column>
          <el-table-column align="center" label="普工二线白班1" min-width="120" prop="jinepugong21"></el-table-column>
          <el-table-column align="center" label="普工三线白班" min-width="120" prop="jinepugong3"></el-table-column>
          <el-table-column align="center" label="普工四线白班" min-width="120" prop="jinepugong4"></el-table-column>
          <el-table-column align="center" label="普工四线白班1" min-width="120" prop="jinepugong41"></el-table-column>
          <el-table-column align="center" label="普工三线白班" min-width="120" prop="jinepugong5"></el-table-column>
          <el-table-column align="center" label="普工三线白班1" min-width="120" prop="jinepugong6"></el-table-column>
          <el-table-column align="center" label="普工一线夜班" min-width="120" prop="jinepugong7"></el-table-column>
          <el-table-column align="center" label="普工一线夜班" min-width="120" prop="jinepugong8"></el-table-column>
          <el-table-column align="center" label="其他" min-width="120" prop="jinepugong9"></el-table-column>
          
          <el-table-column align="center" label="枪手一线白班" min-width="120" prop="jineqiangshou1"></el-table-column>
          <el-table-column align="center" label="枪手一线白班1" min-width="120" prop="jineqiangshou11"></el-table-column>
          <el-table-column align="center" label="枪手二线白班" min-width="120" prop="jineqiangshou2"></el-table-column>
          <el-table-column align="center" label="枪手二线白班1" min-width="120" prop="jineqiangshou21"></el-table-column>
          <el-table-column align="center" label="枪手三线白班" min-width="120" prop="jineqiangshou3"></el-table-column>
          <el-table-column align="center" label="枪手四线白班" min-width="120" prop="jineqiangshou4"></el-table-column>
          <el-table-column align="center" label="枪手四线白班1" min-width="120" prop="jineqiangshou41"></el-table-column>
          <el-table-column align="center" label="枪手三线白班" min-width="120" prop="jineqiangshou5"></el-table-column>
          <el-table-column align="center" label="枪手三线白班1" min-width="120" prop="jineqiangshou6"></el-table-column>
          <el-table-column align="center" label="枪手一线夜班" min-width="120" prop="jineqiangshou7"></el-table-column>
          <el-table-column align="center" label="枪手一线夜班1" min-width="120" prop="jineqiangshou8"></el-table-column>
          <el-table-column align="center" label="其他" min-width="120" prop="jineqiangshou9"></el-table-column>
          
          <el-table-column align="center" label="当日普工工资合计" min-width="100" prop="jinepugongheji"></el-table-column>
          <el-table-column align="center" label="当日枪手工资合计" min-width="100" prop="jineqiangshouheji"></el-table-column>
          <el-table-column align="center" label="本月普工工资" min-width="150" prop="benyuepugong"></el-table-column>
          <el-table-column align="center" label="本月枪手工资" min-width="150" prop="benyueqiangshou"></el-table-column>
        </el-table>
      </div>
    </div>

    
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      today: '',
      sf: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
    
    
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      axios.post(this.$host+'/index.php/admin/Orderexceltwo/tuzhuangliangtinghetongExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '涂装凉亭合同日报表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      this.$request.post('/index.php/admin/Hetongbiao/tuzhuangliangtinghetong', data).then((res) => {
        this.list = res.data.data
        this.listLoading = false
        for(let i in this.list) {
          if(this.list[i].dingdanqianliang<0) {
            this.$message.error('有订单欠量为负数的数据')
          }
          if(this.list[i].dingdanshuliang==0&&this.list[i].dingdanshuliang!='') {
            this.$message.error('有订单数量为0的数据')
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
